<template>
  <Multiselect
    v-model="localValue"
    :options="options"
    :disabled="disabled"
    :multiple="multiple"
    :group-values="groupValues"
    :group-label="groupLabel"
    :group-select="groupSelect"
    :allow-empty="allowEmpty"
    :track-by="trackBy"
    :label="label"
    v-bind="texts"
    @select="select"
    @remove="remove"
  >
    <template v-slot:noOptions>
      Список пуст
    </template>
    <template v-slot:noResult>
      Ничего не найдено
    </template>
    <template v-slot:maxElements>
      Выбрано максимальное количество результатов
    </template>
  </Multiselect>

</template>

<script>
import _ from 'lodash'
import Multiselect from 'vue-multiselect'
import { ruMultiselectSimple, ruMultiselect } from '@/config/multiselect'

export default {
  name: 'MultiSelect',
  components: {
    Multiselect
  },
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    options: {
      type: Array,
      default() {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    trackBy: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    groupValues: {
      type: String,
      default: ''
    },
    groupLabel: {
      type: String,
      default: ''
    },
    groupSelect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      width: 1000,
      localValue: []
    }
  },
  watch: {
    value: {
      deep: true,
      handler(data) {
        this.localValue = data
      }
    }
  },
  computed: {
    texts() {
      return this.width < 768 ? ruMultiselectSimple : ruMultiselect
    }
  },
  created() {
    this.localValue = this.value
    this.width = window.innerWidth || 1000
    window.onresize = () => {
      this.width = window.innerWidth
    }
  },
  methods: {
    select(obj) {
      let currentState = _.cloneDeep(this.localValue)
      if (this.multiple) {
        currentState = [
          ...currentState,
          ...(_.isArray(obj) ? obj : [obj])
        ]
        if (this.trackBy) {
          currentState = _.uniqBy(currentState, this.trackBy)
        }
      } else {
        currentState = obj
      }
      this.$emit('input', currentState)
    },
    remove(obj) {
      let currentState = _.cloneDeep(this.localValue)
      if (this.multiple) {
        const removeList = _.isArray(obj) ? obj : [obj]
        currentState = currentState.filter((s) => !removeList
          .find((r) => (this.trackBy ? s[this.trackBy] === r[this.trackBy] : s === r)))
      } else {
        currentState = null
      }
      this.$emit('input', currentState)
    }
  }
}
</script>

<style scoped>

</style>
